<template>
  <div id="app">
    <loading></loading>
    <router-view></router-view>
    <toast></toast>
  </div>
</template>

<script>
  import Toast from './Toast.vue'
  import Loading from '../modules/helpers/Loading'
  export default {
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    },
    components: {
      toast: Toast,
      Loading
    },
    methods: {
      logout () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }

        this.$router.push('/login')
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// App.vue?34a5ca7b